module.exports = __webpack_public_path__ + "static/Maine detail 2-cd2e08daaa0a90278ed8e83dfff3e624.jpg";